import { PersistentStorage } from '../Storage/PersistentStorage';
var TriggerWithTimeout = /** @class */ (function () {
    function TriggerWithTimeout(widget, trigger, strategy) {
        this._callback = null;
        this._widget = widget;
        this._trigger = trigger;
        this._strategy = strategy;
    }
    TriggerWithTimeout.prototype.register = function (callback) {
        this._callback = callback;
        this._strategy.register(callback, this.calcTimeout());
    };
    TriggerWithTimeout.prototype.destroy = function (callbackOnExpire) {
        if (callbackOnExpire === void 0) { callbackOnExpire = true; }
        if (this._callback && this._trigger.reopenTimeoutEnabled) {
            var newExpireDate = new Date(new Date().getTime() + this._trigger.reopenTimeout * 1000);
            if (!callbackOnExpire || PersistentStorage.set(this.getExpireTimeoutStorageKey(), newExpireDate.toISOString())) {
                this._strategy.destroy(callbackOnExpire ? this.calcTimeout() : NaN);
            }
        }
        else {
            this._strategy.destroy();
        }
    };
    TriggerWithTimeout.prototype.getExpireTimeoutStorageKey = function () {
        var key = this._widget.key || this._widget.type;
        return TriggerWithTimeout.expireTimeoutStorageKey + '-' + key;
    };
    TriggerWithTimeout.prototype.calcTimeout = function () {
        var expireTime = Date.parse(PersistentStorage.get(this.getExpireTimeoutStorageKey()));
        if (expireTime) {
            var nowDate = new Date();
            var expireDate = new Date(expireTime);
            if (expireDate > nowDate) {
                return Math.max(expireDate.getTime() - nowDate.getTime(), this._trigger.timeout * 1000);
            }
        }
        return this._trigger.timeout * 1000;
    };
    TriggerWithTimeout.expireTimeoutStorageKey = 'TriggerWithTimeoutExpire';
    return TriggerWithTimeout;
}());
export { TriggerWithTimeout };
